import { cn } from '@/lib/utils';
import type { CardProps } from '@/types/components.types';

export const Card = ({ children, className }: CardProps) => (
  <div className={cn(
    'bg-zinc-900/50 border border-zinc-800 rounded-xl overflow-hidden',
    className,
  )}>
    {children}
  </div>
);
